import type { Notification } from '@/types/notification';
import { UserAvatar } from '@/components/ui/user-avatar';
import Ionicons from '@expo/vector-icons/Ionicons';
import React from 'react';
import { Pressable, View } from 'react-native';

interface NotificationAvatarProps {
  user?: Notification['user'];
  avatarUrl: string | null;
  iconName: string;
  iconColor: string;
  badgeBg: string;
  onUserPress: () => void;
}

function BadgeIcon({ iconName, badgeBg }: { iconName: string; badgeBg: string }) {
  return (
    <View
      className={`absolute -bottom-0.5 -right-0.5 w-5 h-5 rounded-full items-center justify-center border-2 border-background ${badgeBg}`}
    >
      <Ionicons name={iconName as any} size={11} color="white" />
    </View>
  );
}

export function NotificationAvatar({
  user,
  avatarUrl,
  iconName,
  iconColor,
  badgeBg,
  onUserPress,
}: NotificationAvatarProps) {
  if (user) {
    return (
      <Pressable onPress={onUserPress} className="mr-3">
        <View className="relative">
          <UserAvatar uri={avatarUrl} name={user.name} size={48} className="bg-muted" />
          <BadgeIcon iconName={iconName} badgeBg={badgeBg} />
        </View>
      </Pressable>
    );
  }

  return (
    <View className="w-12 h-12 rounded-full mr-3 items-center justify-center">
      <Ionicons name={iconName as any} size={24} className={iconColor} />
    </View>
  );
}
